import * as gql from 'gql-query-builder';

import { checklistFields, inspectionFields } from './queryFields';

export const getInspectionTypesQuery = gql.query({
  operation: 'inspectionTypes',
  variables: { orderBy: 'sort_index' },
  fields: ['id', 'name'],
});

export const getInspectionTypesByTypeQuery = ({
  typeName,
}: {
  typeName?: string;
}) =>
  gql.query({
    operation: 'getInspectionTypesByType',
    variables: typeName ? { typeName } : undefined,
    fields: ['id', 'name', 'type'],
  });

export const getInspectionTypeByIdQuery = ({ id }: { id: string }) =>
  gql.query({
    operation: 'inspectionType',
    variables: { id: { value: id, required: true } },
    fields: ['id', 'name', 'type'],
  });

export const getInspectionQuery = ({ id }: { id: number }) =>
  gql.query({
    operation: 'inspection',
    variables: { id: { value: id, required: true } },
    fields: inspectionFields,
  });

export const getChecklistQuery = ({ id }: { id: number }) =>
  gql.query({
    operation: 'inspection',
    variables: { id: { value: id, required: true } },
    fields: checklistFields,
  });

export const getInspectionByRepairRequestIdQuery = ({
  repairRequestId,
}: {
  repairRequestId: number;
}) =>
  gql.query({
    operation: 'findByRepairRequestId',
    variables: { repairRequestId: { value: repairRequestId, required: true } },
    fields: inspectionFields,
  });

export const getChecklist = ({
  make,
  model,
  repairIds,
}: {
  make: string;
  model: string;
  repairIds: number[];
}) =>
  gql.query({
    operation: 'getChecklist',
    variables: {
      make: { value: make, required: true },
      model: { value: model, required: true },
      repairIds: { value: repairIds, required: true, list: true, type: 'Int!' },
    },
    fields: ['id', 'name'],
  });
